/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:12:31
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { toVisualThousands } from "../utils";
import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";



export default ({ title, list = [], color = [], brandArr = [] }) => {
  
  return {
    title: {
      text: '数字品牌价值（单位：百万{db|DB}）',
      align: 'left',
      top: 30,
      textStyle: {
        color: '#000',
        rich: {
          db: {
            fontSize: 16,
            fontStyle: 'italic'
          }
        },
      }
      
   },
    legend: {
      show: true,
      width: 400,
      top: 5,
      right: 0,
      itemWidth: 20,
      itemHeight: 10,
      formatter: '{a|{name}}',
      selectedMode: false,
      textStyle: {
        rich:{
          a: {
            width: 36,
            fontSize: 12,
            backgroundColor: "rgba(11, 39, 52, 0)" // 关键代码，设置一个背景并使之透明，否则宽度不生效，配合formatter使用
           },
        } 
      }
    },
    // graphic: createGraphic(brandArr, color),

    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    color,
    grid: {
      top: 70,
      left: 50,
      right: 0,
      bottom: 10,
      containLabel: false,
    },
    xAxis: {
      show: false,
      type: "category",
      data: title,
      axisLabel: { ...xAxisLabelColor },
      axisTick: { show: true },

    },
    yAxis: {
      type: "value",
      // boundaryGap: [0, 0.01],
      axisLine: { show: false },
      axisTick: { show: false },
      minorTick: { show: false },
      splitLine: { show: false },
      axisLabel: { ...yAxisLabelColor },
    },

    series:  brandArr.map((brand, index) => {
      const itemStyle = { color: color[index] };
      return {
        name: brand,
        type: brand == "安踏" ? "bar" : "line",
        barWidth: '30%',
        data: list.map((item) => {
          const result = item[index] / 1000000;
          var roundedResult = Math.round(result * 100) / 100;
          return Number(roundedResult)
          // return item[index]
        }),
        label: {
          show: true,
          position: 'top',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        // itemStyle: {
        //   normal: {
        //     color:brand == "安踏" ? "#ff0000" : color[index],
        //   },
        // },
      }
    }),
  };
};



// WEBPACK FOOTER //
// src/routes/visualChart/P33/chart.js